import { render, staticRenderFns } from "./InputActionStatus.vue?vue&type=template&id=2a86baa2&scoped=true&"
import script from "./InputActionStatus.vue?vue&type=script&lang=js&"
export * from "./InputActionStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a86baa2",
  null
  
)

export default component.exports